import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

export default class SubstanceSupplierData extends React.PureComponent {
  render() {
    const { supplierData, database } = this.props;

    if (!supplierData) return null;

    const renderer = database.isMarketSelect ? renderMarketSelect : renderDefault;

    return renderer(supplierData);
  }
}

function renderDefault({ largestQuantity, avgPriceGram, avgPriceMMol }) {
  return (
    <>
      <strong className="u-els-font-family-bold">Largest Quantity:</strong>
      <InnerHTML tag="div" html={largestQuantity} mode="escape" />

      <strong className="u-els-font-family-bold">Average Price/g ($):</strong>
      <InnerHTML tag="div" html={avgPriceGram} mode="escape" />

      <strong className="u-els-font-family-bold">Average Price/mmol ($):</strong>
      <InnerHTML tag="div" html={avgPriceMMol} mode="escape" />
    </>
  );
}

function renderMarketSelect({ msQuantity, msPricePer250mg }) {
  return (
    <>
      <strong className="u-els-font-family-bold">250 mg Quantity:</strong>
      <InnerHTML tag="div" html={msQuantity} mode="escape" />

      <strong className="u-els-font-family-bold">Price Bin ($ per 250 mg):</strong>
      <InnerHTML tag="div" html={msPricePer250mg} mode="escape" />
    </>
  );
}

SubstanceSupplierData.propTypes = {
  supplierData: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
};
